const formatDate = date => {
  return date
    ? date
        .split('-')
        .reverse()
        .join('-')
    : '';
};

const settlementInitialValues = settlement => {
  const updateSettlement = { ...settlement, balancesToDestroy: [] };
  updateSettlement.issueDate = formatDate(updateSettlement.issueDate);
  updateSettlement.endDate = formatDate(settlement.endDate);
  updateSettlement.paymentDate = formatDate(settlement.paymentDate);
  updateSettlement.noticeDate = formatDate(settlement.noticeDate);
  updateSettlement.terminationReason = settlement.terminationReason?.value || '';
  return updateSettlement;
};

const initialValues = settlement => {
  if (Object.keys(settlement).length) return settlementInitialValues(settlement);
  return {
    employee: {
      id: '',
      employeeId: '',
      nationalIdentification: '',
      jobTitle: '',
      currentContract: '',
      currentContractId: '',
      costCenter: '',
      jobManagement: '',
      subsidiary: '',
      startDate: '',
      branchOffices: [],
      workedTime: '',
      contractType: '',
      functions: '',
      days: '',
      months: '',
      years: '',
      contractBalances: []
    },
    endDate: '',
    issueDate: '',
    paymentDate: '',
    noticeDate: '',
    ufValue: '',
    max90Uf: '',
    simulation: 'false',
    variableIncome: 'false',
    noticeMonth: 'false',
    terminationReason: '',
    terminationReasonObject: '',
    justificationTerminationReason: '',
    payrollId: '',
    legalVacationDays: '',
    aditionalVacationDays: '',
    progressiveVacationDays: '',
    nonWorkingDays: '',
    totalVacationDays: '',
    proportionalVacationDays: '',
    holidayCompensation: {
      variableAssets: [],
      taxableAssets: [],
      notTaxableAssets: []
    },
    pendingRemunerations: [],
    balancesToDestroy: [],
    calculateSummary: false
  };
};

export default initialValues;
